<p-dialog
    appDialogoPadrao="pi pi-wallet"
    descricao="Banco usado na cobrança."
    [(visible)]="showDialog"
    (onShow)="onDialogShow()"
    (onHide)="hideDialog()"
    [breakpoints]="{ '1100px': '75vw', '500px': '90vw' }"
    [header]="banco() ? 'Editar Banco' : 'Novo Banco'"
    styleClass="dialog-fullscreen-mobile"
    [maximizable]="true"
    [appendTo]="'body'"
>
    <ng-template #content>
        <div class="p-fluid" [formGroup]="bancoForm">
            <div class="flex flex-col gap-6">
                <!-- Visualização da Logo centralizada acima -->
                <div class="flex flex-col items-center justify-center p-4 bg-slate-50 dark:bg-slate-800/50 rounded-xl border border-dashed border-slate-300 dark:border-slate-600 w-32 h-32 mx-auto flex-shrink-0">
                    <div class="w-full h-full flex items-center justify-center bg-white dark:bg-slate-900 rounded-lg shadow-sm p-2 overflow-hidden">
                        @if (bancoForm.get('codigo')?.value) {
                            <img [src]="'images/logos/bancos/' + bancoForm.get('codigo')?.value + '.png'" [alt]="bancoForm.get('nome')?.value" class="max-w-full max-h-full object-contain" onerror="this.src = 'images/logos/bancos/default.png'" />
                        } @else {
                            <i class="pi pi-image text-3xl text-slate-300"></i>
                        }
                    </div>
                </div>

                <!-- Campos de edit um abaixo do outro -->
                <div class="flex flex-col gap-4">
                    <div class="field">
                        <label for="codigo" class="font-semibold block mb-2">Código</label>
                        <input pInputText id="codigo" formControlName="codigo" placeholder="Ex: 001" [class.ng-invalid]="isInvalid('codigo')" [class.ng-dirty]="isInvalid('codigo')" />
                        @if (isInvalid('codigo')) {
                            <p-message severity="error" size="small" variant="simple" class="mt-1">Código obrigatório</p-message>
                        }
                    </div>

                    <div class="field">
                        <label for="nome" class="font-semibold block mb-2">Nome</label>
                        <input pInputText id="nome" formControlName="nome" placeholder="Ex: Banco do Brasil" [class.ng-invalid]="isInvalid('nome')" [class.ng-dirty]="isInvalid('nome')" />
                        @if (isInvalid('nome')) {
                            <p-message severity="error" size="small" variant="simple" class="mt-1">Nome obrigatório</p-message>
                        }
                    </div>
                </div>
            </div>
        </div>
    </ng-template>

    <ng-template #footer>
        <p-button label="Cancelar" icon="pi pi-times" text (click)="hideDialog()" />
        <p-button label="Salvar" icon="pi pi-check" [disabled]="bancoForm.invalid" (click)="salvar()" [appCan]="roleBancosEditar" />
    </ng-template>
</p-dialog>
